export default {
  portfolio: {
    // Reglas de universo por jerarquía (R-04/R-06/R-07, §90 Fase 2B)
    scopesTitle: "Reglas de universo",
    scopesNone: "sin reglas · solo las altas manuales",
    scopesCount: "{n} reglas · {cn} CN",
    scopesHintPortfolio: "Todo lo que cumpla una regla cuenta como producto propio, hoy y cuando aparezca un CN nuevo. Ejemplo: tu laboratorio titular.",
    scopesHintCompetitor: "Todo lo que cumpla una regla cuenta como competencia (salvo lo que ya sea tuyo). Ejemplo: un principio activo, un ATC o una agrupación homogénea.",
    scopeKind_lab: "Laboratorio titular",
    scopeKind_pa: "Principio activo",
    scopeKind_atc: "Código ATC (prefijo)",
    scopeKind_ah: "Agrupación homogénea",
    scopeKind_spr: "Conjunto de precios de referencia",
    scopeKind_nregistro: "Nº de registro",
    scopePlaceholder_lab: "p. ej. Normon",
    scopePlaceholder_pa: "p. ej. Olmesartán",
    scopePlaceholder_atc: "p. ej. C09CA",
    scopePlaceholder_ah: "código o nombre de la AH",
    scopePlaceholder_spr: "p. ej. F206",
    scopeCn: "{n} CN",
    scopeAdd: "Añadir regla",
    scopeRemove: "Quitar regla",
    myProducts: "Mis Productos ({n})",
    competitors: "Competidores ({n})",
    saved: "Guardado",
    bulkRemoveProducts: "Quitar los {n} que ves",
    bulkRemoveCompetitors: "Quitar los {n} que ves",
    bulkRemoveProductsTitle: "¿Quitar {n} productos de Mis productos?",
    bulkRemoveCompetitorsTitle: "¿Quitar {n} productos de Competidores?",
    bulkRemoveMessage: "Se quitan los que ves con los filtros puestos. Sus eventos siguen en el histórico. Los que entren por una regla de universo seguirán entrando mientras la regla exista.",
    bulkRemoved: "{n} quitados",
    errorPrefix: "Error: ",
    searchPlaceholder: "Buscar…",
    allTypes: "Todos los tipos",
    allAreas: "Todas las áreas",
    allLabs: "Todos los laboratorios",
    filterNoPresentation: "Sin ninguna presentación comercializada",
    filterCo02: "Sin comercializar 30 meses o más",
    noPresentationSince: "Ninguna presentación desde {date} · {n} meses",
    noPresentationAut: "El nº de registro no tiene ninguna presentación comercializada desde su autorización. A los 3 años la autorización puede caducar (art. 28 RD 1345/2007).",
    noPresentationCese: "El nº de registro no tiene ninguna presentación comercializada desde el último cese conocido. A los 3 años la autorización puede caducar (art. 28 RD 1345/2007).",
    allStatuses: "Todos los estados",
    emptyFiltered: "Ningún producto coincide con los filtros",
    emptyFilteredCompetitors: "Ningún competidor coincide con los filtros",
    typeDirect: "Directo",
    typeTherapeutic: "Terapéutico",
    colProduct: "Producto",
    colActiveIngredient: "P. Activo",
    colTherapeuticArea: "Área Terapéutica",
    colLaboratory: "Laboratorio",
    colStatus: "Estado",
    colType: "Tipo",
    colCompany: "Empresa",
    viewSheetOf: "Ver ficha de {name}",
    newToMarket: "Nuevo en el mercado",
    newToMarketTooltip: "HelixScan lo añadió a tus competidores el {date}: entró al mercado sobre tu principio activo {ingredient}.",
    parallelTitle: "Importaciones paralelas",
    parallelPending: "{n} importaciones paralelas pendientes de decidir",
    parallelPendingOne: "1 importación paralela pendiente de decidir",
    parallelIntro: "Son presentaciones autorizadas en otro país de la UE que comercializa en España un tercero: llevan el sufijo IP en el nº de registro o tienen un nº de registro extranjero. El catálogo las trata como competencia (AP-08), y así cuentan mientras no decidas. Decide una a una o selecciona varias.",
    parallelReview: "Revisar",
    parallelHide: "Ocultar",
    parallelColRegistro: "Nº de registro",
    parallelColTitular: "Titular",
    parallelColOfertante: "La comercializa",
    parallelColDecision: "Se trata como",
    parallelMotivoIp: "Sufijo IP",
    parallelMotivoForeign: "Registro extranjero",
    parallelPendingLabel: "Pendiente · competencia",
    parallelOwn: "Propia",
    parallelCompetitor: "Competencia",
    parallelMarkOwn: "Tratar como propias",
    parallelMarkCompetitor: "Tratar como competencia",
    parallelSelected: "{n} seleccionadas",
    parallelSaved: "Decisión guardada",
    parallelChip: "Importación paralela",
    parallelChipTooltip: "Importación paralela (nº de registro extranjero o con sufijo IP). Decide en Mis productos si es propia.",
    statusActive: "Activo",
    statusInactive: "Inactivo",
    actionViewSheet: "Ver ficha",
    actionDeleteProduct: "Eliminar producto",
    actionDeleteCompetitor: "Eliminar competidor",
    emptyProducts: "Sin productos",
    emptyCompetitors: "Sin competidores",
    confirmDeleteProductTitle: "¿Eliminar producto?",
    confirmDeleteCompetitorTitle: "¿Eliminar competidor?",
    confirmDeleteMessage: "Esta acción no se puede deshacer.",
    modalAddProduct: "Añadir producto",
    modalAddCompetitor: "Añadir competidor",
    fieldCnRequired: "Código CN *",
    fieldProductNameRequired: "Nombre del producto *",
    fieldActiveIngredientRequired: "Principio activo *",
    fieldLaboratory: "Laboratorio",
    fieldTherapeuticArea: "Área terapéutica",
    fieldCn: "Código CN",
    cnPlaceholder: "Ej: 123456",
    fieldCompetitorType: "Tipo de competidor",
    competitorTypeDirect: "Directo (mismo principio activo)",
    competitorTypeTherapeutic: "Terapéutico (misma indicación)",
    fieldCompany: "Empresa",
    fieldProduct: "Producto",
    cancel: "Cancelar",
    save: "Guardar",
  },
};
